import {RemoteDeleteFavoritePlace} from 'data/usecases';
import {DeleteFavoritePlace} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {GuideFlowEndpoints} from 'main/factories/usecases/endpoints';

export const makeDeleteFavoritePlace = (cdBeneficiarioEnderecoFavorito: number): DeleteFavoritePlace =>
  new RemoteDeleteFavoritePlace(
    makeBFFApiUrl(`${GuideFlowEndpoints.medicalFavoritePlace}/${cdBeneficiarioEnderecoFavorito}`),
    makeAuthorizeHttpClientDecorator(),
  );
